import { getMessage } from '../utils/messageUtils'
import './FloatingMenu.scss'
import { useEffect } from 'react'

interface FloatingMenuProps {
  isOpen: boolean
  activeTab: string
  tabs: Array<{ id: string; label: string }>
  onClose: () => void
  onTabSelect: (tabId: string) => void
  onLogout: () => void
}

function FloatingMenu({
  isOpen,
  tabs,
  activeTab,
  onClose,
  onTabSelect,
  onLogout,
}: FloatingMenuProps) {
  // Prevent body scroll when menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
    return () => {
      document.body.style.overflow = ''
    }
  }, [isOpen])

  if (!isOpen) return null

  const handleTabClick = (tabId: string) => {
    if (tabId !== activeTab) {
      onTabSelect(tabId)
    }
    onClose()
  }

  const handleLogout = () => {
    onLogout()
    onClose()
  }

  return (
    <>
      {/* Backdrop */}
      <div className="floating-menu-backdrop" onClick={onClose} />

      {/* Menu */}
      <div className="floating-menu">
        <div className="floating-menu-header">
          <h2>{getMessage('menu')}</h2>
          <button
            className="close-button"
            onClick={onClose}
            aria-label={getMessage('close_menu')}
          >
            ×
          </button>
        </div>

        <nav className="floating-menu-content">
          {tabs && tabs.length > 0 && (
            <div className="menu-section">
              <h3 className="menu-section-title">{getMessage('navigation')}</h3>
              <ul className="menu-list">
                {tabs.map(tab => (
                  <li key={tab.id}>
                    <button
                      className={`menu-item ${activeTab === tab.id ? 'menu-item-active' : ''}`}
                      onClick={() => handleTabClick(tab.id)}
                    >
                      {tab.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          )}

          <div className="menu-section">
            <h3 className="menu-section-title">{getMessage('account')}</h3>
            <ul className="menu-list">
              <li>
                <button
                  className="menu-item logout-item"
                  onClick={handleLogout}
                >
                  {getMessage('logout')}
                </button>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </>
  )
}

export default FloatingMenu
